import { Card, Form, Space } from 'antd';
import * as React from 'react';
import ChangeRequestDTO from '../../../models/ChangeRequestDTO';
import BaseChangeRequestProps from '../../../redux/bases/BaseChangeRequestProps';
import BaseFormProps from '../../../redux/bases/BaseFormProps';
import BaseFormState from '../../../redux/bases/BaseFormState';
import Guid from '../../../utils/Guid';
import ChangeRequestAdditionalDetailsForm from '../../forms/postSecondary/ChangeRequestAdditionalDetailsForm';
import CourseModificationChangeRequestStep1Form from '../../forms/postSecondary/CourseModificationChangeRequestStep1Form';
import CourseModificationChangeRequestStep2Form from '../../forms/postSecondary/CourseModificationChangeRequestStep2Form';

interface CourseModificationChangeRequestDetailsState extends BaseFormState {
}

interface CourseModificationChangeRequestDetailsProps extends BaseFormProps, BaseChangeRequestProps {
  changeRequest: ChangeRequestDTO;
}

class CourseModificationChangeRequestDetails extends React.Component<CourseModificationChangeRequestDetailsProps, CourseModificationChangeRequestDetailsState> {

  constructor(props: CourseModificationChangeRequestDetailsProps) {
    super(props);
  }

  public render = () => {
    return (
      <Form layout="vertical">
        <Space size="large" direction="vertical">
          <Card type='inner' title='Course Selection'>
            <CourseModificationChangeRequestStep1Form readonly={true} loading={this.props.loading} institutionId={this.props.changeRequest.institutionId ?? Guid.Empty()} changeRequestId={this.props.changeRequest.id} changeRequestDetailsPage={this.props.changeRequestDetailsPage} />
          </Card>

          <Card type='inner' title='Course Information'>
            <CourseModificationChangeRequestStep2Form readonly={true} loading={this.props.loading} changeRequestId={this.props.changeRequest.id} changeRequestDetailsPage={this.props.changeRequestDetailsPage} />
          </Card>

          <Card type="inner" size="small" title="Additional Details" >
            <ChangeRequestAdditionalDetailsForm readonly={true} changeRequest={this.props.changeRequest} loading={this.props.loading} fieldErrors={this.props.fieldErrors} submitted={true} />
          </Card>
        </Space>
      </Form >
    );
  }
}

export default CourseModificationChangeRequestDetails;